import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./menu-listar/menu-listar.module').then(m => m.MenuListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./menu-editar/menu-editar.module').then(m => m.MenuEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Inserir' }, loadChildren: () => import('./menu-inserir/menu-inserir.module').then(m => m.MenuInserirModule) }
    ])],
    exports: [RouterModule]
})
export class MenuAppRoutingModule { }